import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import 'moment/locale/ar';

import TRANSLATION_EN from 'translation/lang/en.json';
import TRANSLATION_FR from 'translation/lang/fr.json';
import TRANSLATION_AR from 'translation/lang/ar.json';

// the translations
const resources = {
  en: {
    translation: TRANSLATION_EN,
  },
  fr: {
    translation: TRANSLATION_FR,
  },
  ar: {
    translation: TRANSLATION_AR,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'en',
    keySeparator: '.',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// update dir ang lang html attributes on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = i18n.dir(lng);
  document.documentElement.lang = lng;

  moment.locale(lng);
});

export default i18n;
